import { makeConfig } from './config.common';

const config = makeConfig({
  DOMAIN: 'bbw.date',
  TITLE: 'BBW Date',
  NICHE: 'bbwdate',
  PROJECT: 'bbwdate',
  NICHE_SINGULAR: 'BBW',
  NICHE_PLURAL: "BBW's",
  NICHE_SINGLES: 'BBW Singles',
  FB_TRACKING_PIXEL_ID: ['724457367927734'],
  BING_TRACKING_PIXEL: ['343094434'],
  VERIZON_TRACKING_PIXEL: '10111282',
  TABOOLA_TRACKING_PIXEL: '1800925',
  TYPE: 'mainstream',
  SENTRY_RELEASE: 'www-bbw-date',
  SENTRY_DNS:
    'https://45a0d1112797c9f3018d733ad14727e1@sentry.nearbyapi.com/10',
  VWO_ID: 302021,
});

export default config;



// WEBPACK FOOTER //
// ./src/constants/config.js